import Lottie from "lottie-react"
import accessDenied from "./accessDenied.json";
import { Box, Typography, Button } from '@mui/material';

const NoAccessPage = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
        textAlign: 'center',
        fontFamily: 'Raleway, sans-serif',
      }}
    >
    <Typography variant="h3" sx={{ color: '#EE4B5E', fontWeight: 700 }}>
        ACCESS DENIED
      </Typography>
        <Lottie

            animationData={accessDenied}
            loop={false}
            style={{ width: "180px", height: "180px", margin: "0 auto" }}
        />
   
 
      <Typography
        variant="h5"
        sx={{ color: '#000000ff', fontWeight: 700, mt: 2 ,fontSize:'16px'}}
      >
        Currently, you don't have any access to this application.
      </Typography>
 
      <Typography
        variant="body1"
        sx={{ color: 'white', maxWidth: 600, mt: 3, px: 2 , fontSize:'12px'}}
      >
        Please contact the administrator if you believe this is an error. This
        page is restricted and access has been denied by the server due to
        insufficient permissions.
      </Typography>
 
      <Button
        variant="outlined"
        href="https://www.egtech.in/"
        sx={{
          color: '#EE4B5E',
          borderColor: '#EE4B5E',
          mt: 4,
          textTransform: 'uppercase',
          borderRadius: '26px',
          fontWeight: 700,
          px: 4,
          py: 1.5,
          '&:hover': {
            backgroundColor: '#EE4B5E',
            color: '#FFFFFF',
            borderColor: '#EE4B5E',
          },
        }}
      >
        Go to homepage
      </Button>
    </Box>
  );
}

export default NoAccessPage